/* eslint-disable import/prefer-default-export */
export const phoneNumbers = {
  umaAdmissions: '8882134473',
  //  umaAdvisor: '8554546841', number not active
  umaAlumniPersona: '8882160535',
  umaCareerServices: '8883158211',
  umaClearwater: '7272988685',
  umaDisabilityServices: '8883331454',
  umaEmployerPersona: '8773066185',
  umaFinancialAid: '8882125421',
  umaFormDisclaimer: '8882052510',
  umaMedia: '8136766175',
  umaOnline: '8882052510',
  umaOperations: '8138982588',
  umaRegistrar: '8772418786',
  umaWorkHerePersona: '8136058400',
}
